import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

// import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
// import ButtonBase from '@material-ui/core/ButtonBase';


//icons
import AddIcon from '@material-ui/icons/Add';


//color
// import green from '@material-ui/core/colors/green';
// import red from '@material-ui/core/colors/red';

//
// import Chart from './Chart'
import { Fab } from '@material-ui/core';



const useStyles = makeStyles(theme => ({
    card: {
        // minWidth: 275,
        textAlign: "center",
        margin: 0,
        padding: 0,

    },
    cardContent: {
        margin: 0,
        padding: 0,
        textAlign: "center",
        marginTop: 15
    },
    title: {
        fontSize: 14,
        textAlign: "left",
        marginTop: theme.spacing(2),
        marginLeft: theme.spacing(2)
    },
    iconPos: {
        marginRight: theme.spacing(1),
        paddingTop: theme.spacing(1)
    },
    iconMoeda: {
        margin: 10,
        width: 60,
        height: 60,
        textAlign: 'center'
    },
    chart: {
        height: 40,
        margin: 10,
    },
}));

export default function ButtonAdd({ onClick }) {

    // const props = market ? { color: coin.change > 0 ? green[500] : red[500] } : { color: red[500] }


    const classes = useStyles();
    // const bull = <span className={classes.bullet}>•</span>;

    return (


        <CardContent className={classes.cardContent}>


            {/* <img alt={'Simbolo' + coin.name} src={coin.iconUrl} className={classes.iconMoeda} /> */}

            <Fab
                className={classes.iconMoeda}
                aria-label={'Add Moeda'}
                color="primary"
                onClick={onClick}
            >
                <AddIcon />
            </Fab>

            {/* <Typography>
                        Linguiça
                    </Typography> */}

            <Typography variant="h6">
                Novo
            </Typography>

            {/* {
                        market ||
                        <Typography variant="h6">
                            {
                                volume !== 0 ?
                                    fiat ? parseFloat(volume).toLocaleString('pt-BR', { minimumFractionDigits: 2 })
                                        : parseFloat(volume).toLocaleString('pt-BR', { minimumFractionDigits: 8 })
                                    :
                                    'Digite uma quantia'
                            }
                        </Typography>
                    } */}

        </CardContent>
    );
}